import axios from 'axios';

const axiosIns = axios.create({
  headers: {
    'Content-type':'application/json',
  },
  baseURL: process.env.REACT_APP_BASE_URL
});

const axiosInsPaymentLinks =  axios.create({
  headers: {
    'Content-type':'application/json',
  },
  baseURL: process.env.REACT_APP_PARTIAL_PAYMENT_URL
});
export { axiosIns, axiosInsPaymentLinks }

